import React from 'react';
import { Box, Card, CardContent, CardHeader, Grid, Typography } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";


function SampleAnalyzerDataCards({ analyzers }) {

  if (analyzers) {
    return (
      analyzers.map((analyzer, index) => (
        <Card
          key={index}
          sx={{ color: 'white', bgcolor: 'background.dark' }}
        >
          <CardContent>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Typography component="span" sx={{ fontWeight: 600 }}>{analyzer.displayName}</Typography>
              <span> {analyzer.unit !== undefined ? analyzer.value : "-"} {analyzer.unit}</span>
              <InfoIcon sx={{ fontSize: 24, color: "text.secondary" }} />
            </Box>
            <Box sx={{ my: 1, fontSize: "1rem" }}>
              {analyzer.analyzerDiagnostics && analyzer.analyzerDiagnostics.map((ad, index) => {
                let fixedValue = ad.unit !== undefined ? parseFloat(ad.value).toFixed(2) : "-";
                return (
                  <Grid container key={index}>
                    <Grid size={8}>{ad.name}</Grid>
                    <Grid size={4}>{fixedValue + " " + (ad.unit ?? "")}</Grid>
                  </Grid>)
              })
              }
            </Box>
          </CardContent>
        </Card>
      ))
    );
  } else {
    return null;
  }
}

export default SampleAnalyzerDataCards;